import React, { useState, useEffect } from "react";
import { FaTimes } from "react-icons/fa";
import BtnGuardar from "../../../components/buttons/BtnGuardar";
import BtnCancelar from "../../../components/buttons/BtnCancelar";
import ContratoAutocomplete from "../../../components/autocomplete/ContratoAutocomplete";
import TarjetasAutocomplete from "../../../components/autocomplete/TarjetasAutocomplete";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson, notify } from "../../../utils/http";

export default function EditarContratoTarjeta({ initial, onClose, onSaved }) {
  const [contratoObj, setContratoObj] = useState(null);
  const [tarjetaObj, setTarjetaObj] = useState(null);
  const [estadoId, setEstadoId] = useState("");
  const [estados, setEstados] = useState([]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  // Cargar estados con tipoId=20
  useEffect(() => {
    const fetchEstados = async () => {
      try {
        const url = apiRoutes.estados.listUrl({ tipoId: 20, size: 100 });
        const res = await appFetchJson(url);
        const items = res?.items || res?.content || [];
        setEstados(items);
      } catch (e) {
        console.error("Error cargando estados:", e);
      }
    };
    fetchEstados();
  }, []);

  // Inicializar datos
  useEffect(() => {
    if (initial) {
      if (initial.contratoId) {
        setContratoObj({ id: initial.contratoId, codigo: initial.contratoCodigo });
      }
      if (initial.tarjetaId) {
        setTarjetaObj({ id: initial.tarjetaId, numero: initial.tarjetaNumero });
      }
      setEstadoId(initial.estadoId || "");
    }
  }, [initial]);

  const isValid = contratoObj && tarjetaObj && estadoId;

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const handleSave = async () => {
    if (!isValid || saving) return;
    setSaving(true);
    setError("");

    const payload = {
      contratoId: contratoObj.id,
      tarjetaId: tarjetaObj.id,
      estadoId: estadoId,
    };

    try {
      const url = apiRoutes.contratoTarjeta.editarUrl(initial.id);
      const updated = await appFetchJson(url, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      notify({ type: "success", message: "Asignación actualizada correctamente" });
      onSaved(updated);
      onClose();
    } catch (e) {
      console.error("Error editando asignación:", e);
      setError(e?.message || "Error al actualizar la asignación.");
      notify({ type: "error", message: e?.message || "Error al actualizar la asignación." });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-panel-lg" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header flex justify-between items-center">
          <h2 className="section-title">Editar Asignación Contrato-Tarjeta</h2>
          <button className="modal-close-x" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <p className="text-gray-600 mb-4 italic">
            Modifique los datos de la asignación.
          </p>

          {error && <div className="text-red-600 mb-3 font-medium">{error}</div>}

          <div className="form-grid">
            <div className="form-row col-span-2">
              <label className="form-label">Contrato *</label>
              <ContratoAutocomplete
                value={contratoObj}
                onChange={setContratoObj}
                placeholder="Buscar por código..."
              />
            </div>

            <div className="form-row col-span-2">
              <label className="form-label">Tarjeta *</label>
              <TarjetasAutocomplete
                value={tarjetaObj}
                onChange={setTarjetaObj}
                placeholder="Buscar por número..."
              />
            </div>

            <div className="form-row col-span-2">
              <label className="form-label">Estado *</label>
              <select
                className="input w-full"
                value={estadoId}
                onChange={(e) => setEstadoId(e.target.value)}
              >
                {estados.map((est) => (
                  <option key={est.id} value={est.id}>
                    {est.nombre}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <div className="btn-row">
            <BtnGuardar
              label={saving ? "Guardando..." : "Guardar Cambios"}
              isValid={isValid}
              saving={saving}
              onClick={handleSave}
            />
            <BtnCancelar onClick={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}